export interface SseMessage {
  id?: string;
  event: string;
  data: string;
}

/** Bộ phân tích luồng text/event-stream (hỗ trợ chunk cắt ngang dòng, \r\n, comment, nhiều dòng data). */
export function createSseParser(onMessage: (m: SseMessage) => void) {
  let buffer = '';
  let id: string | undefined;
  let event = '';
  let data: string[] = [];

  const dispatch = () => {
    if (data.length) onMessage({ id, event: event || 'message', data: data.join('\n') });
    event = '';
    data = [];
  };

  return {
    push(chunk: string) {
      buffer += chunk;
      let idx: number;
      while ((idx = buffer.search(/\r\n|\n|\r/)) >= 0) {
        const line = buffer.slice(0, idx);
        const sepLen = buffer.startsWith('\r\n', idx) ? 2 : 1;
        buffer = buffer.slice(idx + sepLen);
        if (line === '') { dispatch(); continue; }
        if (line.startsWith(':')) continue; // comment / heartbeat
        const c = line.indexOf(':');
        const field = c < 0 ? line : line.slice(0, c);
        let value = c < 0 ? '' : line.slice(c + 1);
        if (value.startsWith(' ')) value = value.slice(1);
        if (field === 'data') data.push(value);
        else if (field === 'event') event = value;
        else if (field === 'id') id = value;
      }
    },
  };
}
